module.exports = __webpack_public_path__ + "img/priority-high.ebf7e426.svg";